export default __webpack_public_path__ + "static/media/Ilan Edri Resume.723f5718.pdf";